export interface NameInputProps {
  // add props here
}

export const NAME_LENGTH_LIMIT = 75;

export const isEventNameComplete = (name: string): boolean => {
  return name.trim() !== '';
};